<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.checkVersion().then(() => {
      // this.checkHttps()
      // this.checkHash()
    });
  },
  methods: {
    checkHttps() {
      if (location.protocol === "http:") {
        return (window.location.href = "https://www.kmppartners.info/ebidding");
      }
    },
    checkHash() {
      if (location.hash !== "") {
        window.location.href = "https://www.kmppartners.info/ebidding";
      }
    },
    checkVersion() {
      return axios
        .post("https://www.kmppartners.info:1030/api/ebidding/version", {
          version: "64.04.27.01",
        })
        .then((res) => {
          if (!res.data.status) {
            location.reload();
          }
        });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
